module.exports = __webpack_public_path__ + "assets/img/TLSC3-3.67ca6b97.jpg";